import { render } from "./labor.vue?vue&type=template&id=9c628e3c"
import script from "./labor.vue?vue&type=script&lang=js"
export * from "./labor.vue?vue&type=script&lang=js"

import "./labor.vue?vue&type=style&index=0&id=9c628e3c&lang=css"

import exportComponent from "C:\\Project\\VuePro\\DTP\\dtp_index\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__